"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../../../api/webAApi");
var EventBindingOnDepositCfgCtl = /** @class */ (function (_super) {
    __extends(EventBindingOnDepositCfgCtl, _super);
    function EventBindingOnDepositCfgCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this._errDialog = errDialog;
        return _this;
    }
    EventBindingOnDepositCfgCtl.prototype.ResetData = function () {
        this.DATA = {
            is_bonus_create_on_deposit_exact_order_number: false,
            bonus_deposit_exact_order_number_to_create: 0,
        };
    };
    EventBindingOnDepositCfgCtl.prototype.LoadData = function (key, onDone) {
        var _this = this;
        webAApi_1.DetailsBrandBonusEventBindingConfigOnDepGet.exec({ event_binding_id: key }, function (resp) {
            _this.DATA.is_bonus_create_on_deposit_exact_order_number = resp.is_bonus_create_on_deposit_exact_order_number;
            _this.DATA.bonus_deposit_exact_order_number_to_create = resp.bonus_deposit_exact_order_number_to_create;
            //this.DATA.is_bonus_create_on_deposit_less_or_eq_then_order_number = resp.is_bonus_create_on_deposit_less_or_eq_then_order_number;
            //this.DATA.bonus_deposit_less_or_eq_then_order_number_to_create = resp.bonus_deposit_less_or_eq_then_order_number_to_create;
            //this.DATA.is_bonus_create_on_deposit_greater_then_order_number = resp.is_bonus_create_on_deposit_greater_then_order_number;
            //this.DATA.bonus_deposit_greater_then_order_number_to_create = resp.bonus_deposit_greater_then_order_number_to_create;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    EventBindingOnDepositCfgCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoEditBrandBonusEventBindingConfigOnDep.exec({
            data: {
                event_binding_id: data.event_binding_id,
                is_bonus_create_on_deposit_exact_order_number: data.is_bonus_create_on_deposit_exact_order_number,
                bonus_deposit_exact_order_number_to_create: data.bonus_deposit_exact_order_number_to_create,
            }
        }, function (resp) {
            _this.DATA.is_bonus_create_on_deposit_exact_order_number = data.is_bonus_create_on_deposit_exact_order_number;
            _this.DATA.bonus_deposit_exact_order_number_to_create = data.bonus_deposit_exact_order_number_to_create;
            //this.DATA.is_bonus_create_on_deposit_less_or_eq_then_order_number = data.is_bonus_create_on_deposit_less_or_eq_then_order_number;
            //this.DATA.bonus_deposit_less_or_eq_then_order_number_to_create = data.bonus_deposit_less_or_eq_then_order_number_to_create;
            //this.DATA.is_bonus_create_on_deposit_greater_then_order_number = data.is_bonus_create_on_deposit_greater_then_order_number;
            //this.DATA.bonus_deposit_greater_then_order_number_to_create = data.bonus_deposit_greater_then_order_number_to_create;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    return EventBindingOnDepositCfgCtl;
}(BaseController_1.BaseController));
exports.EventBindingOnDepositCfgCtl = EventBindingOnDepositCfgCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_events_bindings/ctl/event_config/config_on_deposit/EventBindingOnDepositCfgCtl.ts
// module id = 979
// module chunks = 0